<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" class="py-0">
                <v-toolbar class="py-0 my-0" dark color="#d98880">
                    <v-toolbar-title class="my-0 py-0">AUTOINSPECCIÓN DE PROCESOS (EI
                        057) </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="6" sm="2" md="2">
                            <v-text-field label="Filtro por Cliente" dense v-model="cliente"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="2" md="3">
                            <v-text-field label="Filtro por Obra" dense v-model="obra"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <v-text-field label="Filtro por Responsable" dense v-model="resp"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="2" md="3">
                            <v-text-field label="Filtro por Proceso" dense v-model="proceso"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <v-text-field label="Filtro por N° de OT" dense v-model="numot"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="2" md="4">
                            <v-btn tile color="success" @click="cargarListados()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card v-model="show" color="#FFFF99">
                <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                    :items-per-page="50000" hide-default-footer :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                    <template v-slot:top>
                        <v-toolbar flat dense>
                            <v-toolbar-title center>
                                <font color="green">
                                    Listado de Autoinspecciones de Procesos - {{ codgral }}
                                </font>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click="ver(item)">
                                    mdi-eye
                                </v-icon>
                            </template>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="orange darken-2" v-on="on" v-bind="attrs"
                                    @click="revisar(item)">
                                    mdi-refresh
                                </v-icon>
                            </template>
                            <span>Nueva revisión</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
            <Informe :visible="showInforme" :codint="editedItem.codint" @close="showInforme = false">
            </Informe>
            <Revision :visible="showRevision" :codint="editedItem.codint" @close="showRevision = false; cargarListados()">
            </Revision>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth";
import Informe from "../EI057/Informe.vue";
import Revision from "../EI057/Revision.vue";
export default {
    components: { Informe, Revision },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        numot: "",
        resp: "",
        cliente: "",
        obra: "",
        proceso: "",
        listado: [],
        showInforme: false,
        showRevision: false,
        loadtable: false,
        headers: [
            { text: "Código", align: "start", sortable: false, value: "codigo" },
            { text: "Cliente", value: "cliente", sortable: false },
            { text: "Obra", value: "obra", sortable: false },
            { text: "Proceso", value: "proceso", sortable: false },
            { text: "Referencia", value: "referencia", sortable: false },
            { text: "Fecha", value: "fechaesp", sortable: false },
            { text: "N° de OT", value: "numot", sortable: false },
            { text: "Generó", value: "aproboesp", sortable: false },
            { text: "Rev.", value: "revision", align: "center", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],

    }),
    props: ["visible", "codgral"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListados();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;

            axios
                .get("/Ingenieria/EI057Listadocompleto?", {
                    params: {
                        cliente: self.cliente,
                        obra: self.obra,
                        proceso: self.proceso,
                        aproboesp: self.resp,
                        numot: self.numot
                    },
                })
                .then((response) => {

                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];

                    console.log(error);
                });
        },
        ver(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showInforme = true;
        },
        generar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showGenerar = true;
        },
        revisar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showRevision = true;
        },
        vaciarModels() {
            this.listado = [];

        },
    },
};
</script>